/**
 * Fallback premium pricing shown in the paywall when Stripe billing is
 * not configured on the server (US165).
 *
 * This keeps the paywall from showing a blank or broken CTA. The values
 * are GBP-first because the product is UK-based, but they represent the
 * intended starting price regardless of the user's currency. The real
 * Stripe prices, when configured, always override these placeholders.
 *
 * Update these constants without changing code when the target pricing
 * changes.
 */

export const FALLBACK_PREMIUM_PRICE_GBP = 4.99;

export const FALLBACK_PREMIUM_PRICE_USD = 5.99;

export const FALLBACK_PREMIUM_CURRENCY: "gbp" | "usd" = "gbp";
